module.exports = __webpack_public_path__ + "media/images/login/btn_demo_ov-828e2bbd1d22b1bdd065d4d4b8a905f7.png";